export default () => `
    id
    org
    companyName
    fdaApprovalDate
    drugDescription
    createdDate
    createdBy
`;
